const quotes = [
  {
    name: 'Radha Vyas',
    position: 'CEO, Flash Pack',
    quote: 'True innovation in action.',
    image: 'https://cdn.welovealfa.com/Radha-Vyas.jpeg',
  },
  {
    name: 'Rachel Carrell',
    position: 'CEO, Koru Kids',
    quote: 'This product is still so impressive.',
    image: 'https://cdn.welovealfa.com/Rachel-Carrell.jpeg',
  },
  {
    name: 'Lauren Murrell',
    position: 'CEO, By Sarah',
    quote: 'Alfa seems like a great tool.',
    image: 'https://cdn.welovealfa.com/Lauren-Murrell.jpeg',
  },
  {
    name: 'Rajeeb Dey MBE',
    position: 'CEO, Learnerbly',
    quote: 'Alfa could save a lot of time.',
    image: 'https://cdn.welovealfa.com/Rajeeb-Dey-MBE.jpeg',
  },
  {
    name: 'Sarah Touzani',
    position: 'CEO, Waggle AI',
    quote: 'This is truly amazing!',
    image: 'https://cdn.welovealfa.com/Sarah-Touzani.jpeg',
  },
  {
    name: 'Foong Ng',
    position: 'CEO, Matchable',
    quote: 'My mind is blown!',
    image: 'https://cdn.welovealfa.com/Foong-Ng.jpeg',
  },
  {
    name: 'Dr. Dupe Burgess',
    position: 'CEO, Bloomful',
    quote: 'Wow this is super cool!',
    image: 'https://cdn.welovealfa.com/Dr-Dupe-Burgess.jpeg',
  },
  {
    name: 'Amin Hamzianpour',
    position: 'CEO, Qube',
    quote: 'Yes, so pumped for this!',
    image: 'https://cdn.welovealfa.com/Amin-Hamzianpour.jpeg',
  },
  {
    name: 'Sophie Deen',
    position: 'CEO, Bright Little Labs',
    quote: 'This is amazing!!!',
    image: 'https://cdn.welovealfa.com/Sophie-Deen.jpeg',
  },
  {
    name: 'Helene Guillaume Pabis',
    position: 'CEO, Wild.ai',
    quote: 'So much time saved.',
    image: 'https://cdn.welovealfa.com/Helene-Guillaume-Pabis.jpeg',
  },
  {
    name: 'James Mitra',
    position: 'CEO, JBM',
    quote: 'Very cool mate, this is awesome.',
    image: 'https://cdn.welovealfa.com/James-Mitra.jpeg',
  },
  {
    name: 'Dhruvin Patel',
    position: 'CEO, Ocushield',
    quote: 'The future of recruitment is here!',
    image: 'https://cdn.welovealfa.com/Dhruvin-Patel.jpeg',
  },
];

export default quotes;
